// this is an autogenerated file from App/Account/Content/Tasks/mutation-create-stage-subscriber.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks(
  $board_id: uuid!
  $stage_id: uuid!
  $user_id: uuid!
) {
  insert_tasks_subscribers_one(
    object: { board_id: $board_id, stage_id: $stage_id, user_id: $user_id }
    on_conflict: {
      constraint: subscribers_stage_id_user_id_key
      update_columns: []
    }
  ) {
    id
  }
}

`